import { Component, Vue } from 'nuxt-property-decorator'
import LotInfo from '~/models/lotInfo'
import { LotTypes } from '~/enums/lots'
import { PublicProject } from '~/models/project'
import { RentalUnit } from '~/models'

@Component
export default class LotUtilsMixin extends Vue {
  isNumeric(value: string): boolean {
    return /^-?\d*\.?\d+$/.test(value)
  }

  price(lotInfo: LotInfo, lotType: string) {
    let price: any
    if (lotType === LotTypes.HOME || lotType === LotTypes.RESERVED) {
      price = lotInfo.listing_price
    } else if (lotType === LotTypes.HOME_SITE) {
      price = lotInfo.homesite_price
    }

    return this.formatPrice(price)
  }

  rentalPrice(rentalUnit: RentalUnit) {
    const price: any = rentalUnit && rentalUnit?.rental_listing?.base_rent
    return this.formatPrice(price)
  }

  formatPrice(price: number | string) {
    if (!price) {
      return '-'
    }

    if (typeof price === 'number') {
      return this.$options.filters.currency(price)
    }

    if (price && typeof price === 'string') {
      return !this.isNumeric(price)
        ? price
        : this.$options.filters.currency(price)
    }

    return '-'
  }

  formatPriceNoDecimals(value: number | string): string {
    if (value === null || value === undefined || value === '') return '-'
    const num = Number(value)
    if (isNaN(num)) {
      return value as string
    }
    return '$' + num.toLocaleString('en-US', { maximumFractionDigits: 0 })
  }

  getLotType(project: PublicProject, lotInfo: LotInfo) {
    const isDeniedOrPending: boolean = ['denied', 'pending'].includes(
      lotInfo.architectural_status
    )
    if (project?.config?.hide_spec_denied_and_pending && isDeniedOrPending) {
      return LotTypes.HOME_SITE
    }

    return lotInfo.type
  }

  toOrdinal(number: number) {
    const suffixes = ['th', 'st', 'nd', 'rd']
    const lastTwoDigits = number % 100
    // Use lastTwoDigits to calculate the index of the correct suffix to append to number.
    return (
      number +
      (suffixes[(lastTwoDigits - 20) % 10] ||
        suffixes[lastTwoDigits] ||
        suffixes[0])
    )
  }
}
